const heatMapTheme = {
	colors: ["#FFB942", "#DC322F", "#67CA76", "#5BB4DB", "#298EC3"],
	yAxis: {
		gridLineColor: "#E6E6E6",
		lineColor: "#E6E6E6",
		minorGridLineColor: "#E6E6E6",
		tickColor: "#E6E6E6",
		tickWidth: 1
	}
};

export default heatMapTheme;



// WEBPACK FOOTER //
// ./src/components/charts/highcharts-themes/heatMapTheme.js